import { createSelector } from 'reselect';

import { TRANSFER_STATES } from '../constant/transfer-states';

import { allowedSizeSelector } from '@app/store/selector/transfers';

const transferSelector = (state) => state.transfer;

export const transferUploadInProgress = createSelector(
  transferSelector,
  (transfer) => {
    return [TRANSFER_STATES.STARTED, TRANSFER_STATES.PAUSED].includes(
      transfer.state
    );
  }
);

export const getCurrentSize = createSelector(transferSelector, (transfer) => {
  if (!transfer) {
    return 0;
  }

  const items = transfer.items || transfer.files || [];

  return items.reduce((currentSize, { size }) => {
    const fileSize = Number(size);
    if (!isNaN(fileSize)) {
      return currentSize + fileSize;
    }
    return currentSize;
  }, 0);
});

export const getRemainingSize = createSelector(
  allowedSizeSelector,
  getCurrentSize,
  (allowedSize, currentSize) => {
    return allowedSize - currentSize;
  }
);

export const getIsForwardedTransfer = createSelector(
  [transferSelector],
  (transfer) => {
    return !!transfer.parent_id;
  }
);
